import $ from 'jquery';
import SimpleScrollbar from '../vendor/simple-scrollbar';

class SingleProduct {
  constructor() {
    this.addToCartBtnWrap = $('.js-single-product-variation-wrap');
    this.price = $('.js-single-product-price');
    this.wocommerceMsg = $('.woocommerce-message');
    this.questionsForm = $('.js-questions-form');
    this.attributesSelect = $('.js-product-attributes-select');
    this.outOfStockMsg = $('.js-product-attributes-out-of-stock');

    $(window).on('load', () => {
      // if (this.wocommerceMsg.length) {
      //   this.price.hide();
      // }
      // this.addToCartBtnWrap.animate({ opacity: 1 }, 300);
    });

    this.toggleQuestionsForm();

    // this.togglePriceVisibility();

    this.outOfStockAddtoCart();
    this.outOfStockMessagePrepare();
    this.attributesSelectHandler();

    this.tabsInit();
  }

  attributesSelectHandler() {
    if (!this.attributesSelect.length) {
      return;
    }

    $.each(this.attributesSelect, (i, el) => {
      const select = $(el);
      const selection = select.find('li.is-selection');
      const item = select.find('li').not('.is-selection');
      const icon = select.parent().find('.js-product-attributes-select-icon');
      const scrollArea = select.find('.js-product-attributes-select-scroll');

      select.closest('.c-single-product__side-attr').addClass('has-select');

      SimpleScrollbar.initEl(scrollArea[0]);

      icon.on('click', () => {
        select.toggleClass('is-open');
      });
      // .on('mouseenter', () => {
      //   selection.addClass('is-hover');
      // })
      // .on('mouseleave', () => {
      //   selection.removeClass('is-hover');
      // });

      selection.on('click', e => {
        if (
          $(e.target).hasClass('js-single-add-to-cart-btn') ||
          $(e.target).closest('.js-single-add-to-cart-btn').length
        ) {
          return;
        }
        select.toggleClass('is-open');
      });

      item.on('click', e => {
        const self = $(e.currentTarget);
        selection.html(self.html());
        selection.attr('data-selection', self.attr('data-selection'));
        select.removeClass('is-open');
        item.removeClass('is-active');
        self.addClass('is-active');
      });

      if (item.length) {
        $.each(item, (index, elem) => {
          const defaultValue = $(elem).attr('data-default');

          if (defaultValue === 'yes') {
            $(elem).trigger('click');
          }
        });
      }
    });

    $(document).on('click', e => {
      const target = $(e.target);

      if (!target.closest('.js-product-attributes-wrapper').length) {
        this.attributesSelect.removeClass('is-open');
      }
    });
  }

  toggleQuestionsForm() {
    if (!this.questionsForm.length) {
      return;
    }

    this.questionsFormHeader = this.questionsForm.find(
      '.js-questions-form-header',
    );
    this.questionsFormInner = this.questionsForm.find(
      '.js-questions-form-inner',
    );

    this.questionsFormHeader.on('click', () => {
      this.questionsFormInner.slideToggle();
    });
  }

  togglePriceVisibility() {
    this.variationPrice = this.addToCartBtnWrap.find('.single_variation');
    this.variations = $('.js-single-product-variations');

    if (!this.variations.length || !this.price.length) {
      return;
    }

    $(window).on('load', () => {
      setTimeout(() => {
        if (this.variationPrice.css('display') !== 'none') {
          this.price.hide();
        } else {
          this.price.show();
        }
        this.addToCartBtnWrap.animate({ opacity: 1 }, 300);
      }, 300);
    });

    this.variationsOptions = this.variations.find('select');

    this.variationsOptions.on('change', e => {
      const self = $(e.target);

      this.addToCartBtnWrap.find('.js-single-product-select-error').remove();

      if (self.val().trim() !== '') {
        setTimeout(() => {
          const priceHtml = this.variationPrice.find(
            '.woocommerce-variation-price',
          );

          if (priceHtml.length && priceHtml.text().trim() === '') {
            priceHtml.html(
              `<span class="price"><span class="woocommerce-Price-amount amount">${this.price.text()}</span></span>`,
            );
          }
        }, 300);
        this.price.hide();
      } else {
        setTimeout(() => {
          this.price.show();
        }, 300);
      }
    });
  }

  outOfStockAddtoCart() {
    this.addToCartBtn = $('.js-add-to-cart-btn');
    this.variationsDropdown = $('.js-product-variations-dropdown');

    if (!this.addToCartBtn.length) {
      return;
    }

    this.addToCartBtn.on('click', e => {
      const self = $(e.currentTarget);

      if (
        self.hasClass('disabled') ||
        self.hasClass('wc-variation-selection-needed')
      ) {
        e.preventDefault();
        e.stopPropagation();

        if (self.hasClass('wc-variation-selection-needed')) {
          const attributeName = this.variationsDropdown.attr(
            'data-product-variation',
          );
          this.addToCartBtnWrap
            .find('.js-single-product-select-error')
            .remove();
          this.addToCartBtnWrap.append(
            `<div class="o-layout__item o-layout__item--gutless c-single-product__select-error js-single-product-select-error">Select ${attributeName}</div>`,
          );
        }
      }
    });
  }

  outOfStockMessagePrepare() {
    if (this.outOfStockMsg.length) {
      this.outOfStockMsg.parent().addClass('is-out-of-stock');
    }
  }

  tabsInit() {
    this.tabsNav = $('.js-course-tabs-nav');

    if (!this.tabsNav.length) {
      return;
    }

    this.tabsNavLink = this.tabsNav.find('.js-course-tabs-nav-link');
    this.tabs = $('.js-course-tabs');
    this.tab = this.tabs.find('.js-course-tab');

    // make tabs active
    $(window).on('load popstate', event => {
      const tabActive = window.location.hash;

      if (tabActive.trim() !== '') {
        if ($(tabActive).length) {
          const tabLinkClicked = this.tabsNav.find(
            `.js-course-tabs-nav-link[href="${tabActive}"]`,
          );
          this.switchTabs(
            this.tabs,
            tabActive,
            this.tabsNavLink,
            tabLinkClicked,
            event.type === 'load',
          );
        }
      }
    });

    this.tabsNavLink.on('click', e => {
      e.preventDefault();

      const self = $(e.currentTarget);
      const tabId = self.attr('href');

      if ($(tabId).length) {
        this.switchTabs(this.tabs, tabId, this.tabsNavLink, self);
      }
    });
  }

  switchTabs(tabs, newTabId, tabsNavLink, tabLinkClicked, scrollToTab = false) {
    this.activeTabId = tabs.find('.js-course-tab.is-active').length
      ? `#${tabs.find('.js-course-tab.is-active').attr('id')}`
      : '';
    const newTab = $(newTabId);

    if (this.activeTabId !== newTabId) {
      tabsNavLink.removeClass('is-active');
      tabLinkClicked.addClass('is-active');

      $(this.activeTabId)
        .removeClass('is-active')
        .hide();

      $(newTabId).fadeIn(300, () => {
        $(newTabId).addClass('is-active');
        window.history.pushState({}, null, newTabId);
      });
    }

    if (newTab.length && scrollToTab) {
      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: newTab.offset().top - 250,
          },
          500,
        );
    }
  }
}

export default new SingleProduct();



// WEBPACK FOOTER //
// ./src/scripts/modules/single-product.js